import NetworkProvider from '../Provider';

const url = '/api/v1/verify/google';

const verifyWithGoogle = async (accessToken) => {
  const payload = {
    accessToken,
  };
  return NetworkProvider().post(url, payload);
};

export default verifyWithGoogle;